/* eslint-disable */
import qFetch from '@/utils/qFetch'
import { Sniff } from '@/utils/q_sniff'

export function qFetchHouseNew(params) {
  const url = '/bnbapp-node-cq/app/promotion/search/searchhousebyhouseidlist/v2'
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: params,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function qFetchHouse(params) {
  const url = '/bnbbingo/app/promotion/search/searchhousebyhouseidlist/v2'
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: params,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function qFetchBrandHouse(params) {
  const url = '/bnbbingo/app/promotion/search/searchbylandlords'
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: params,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

export function qFetchHouseWithFilter(params) {
  const url = '/bnbbingo/app/promotion/search/searchhousewithfilter'
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: params,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

/**
 * 搜索系统
 * @param {number} cityId 城市id
 */
export function qSearchHouse(params) {
  const url = '/bnbapp-node-cq/v2/app/search/searchhouseForCMS/bnb'
  return qFetch({
    url: '/tjbnb/app/common/nologin',
    data: params,
    extraParam: {
      u: url
    },
    extraCParams: {
      newPlatform: true
    }
  }).then((res) => {
    return Promise.resolve(res)
  })
}

/**
 * 收藏/取消收藏
 */
export function QFetchFavirote(ids, fromDate, toDate) {
  const { isLike, id, itemData } = ids
  const url = isLike ? '/tjbnb/app/favorite/delete' : '/tjbnb/app/favorite/submit'
  return qFetch({
    url,
    encrypt: false,
    data: {
      houseId: id,
      source: 'activeityPage',
      fromDate,
      toDate,
      price: itemData.finalPrice || itemData.productPrice
    }
  })
    .then((res) => {
      return Promise.resolve(res)
    })
    .catch((err) => { })
}

/**
 * 获取所有收藏房屋
 */
export function QFetchFaviroteList() {
  return new Promise((resolve, reject) => {
    if (!Sniff.isLogin) {
      resolve([])
      return
    }
    qFetch({
      url: '/tjbnb/app/favorite/getHouseId'
    })
      .then((res) => {
        if (res.ret && res.data) {
          const houseIds = res.data.houseIds || []
          resolve(houseIds)
          return
        }
        resolve([])
      })
      .catch((err) => {
        resolve([])
      })
  })
}


